import { render, staticRenderFns } from "./GeneralHero.vue?vue&type=template&id=12027091&scoped=true&"
import script from "./GeneralHero.vue?vue&type=script&lang=js&"
export * from "./GeneralHero.vue?vue&type=script&lang=js&"
import style0 from "./GeneralHero.vue?vue&type=style&index=0&id=12027091&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12027091",
  null
  
)

export default component.exports